/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeflyerssize2Inputs */

const en_placeflyerssize2 = /** @type {(inputs: Placeflyerssize2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size`)
};

const de_placeflyerssize2 = /** @type {(inputs: Placeflyerssize2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Größe`)
};

/**
* | output |
* | --- |
* | "Size" |
*
* @param {Placeflyerssize2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeflyerssize2 = /** @type {((inputs?: Placeflyerssize2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeflyerssize2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeflyerssize2(inputs)
	return de_placeflyerssize2(inputs)
});
export { placeflyerssize2 as "placeFlyersSize" }